module.exports = __webpack_public_path__ + "static/media/subtract 3.e9a89112.webp";